"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var a11y_menu_1 = require("@wanjapflueger/a11y-menu");
var navs = document.querySelectorAll('nav');
if (navs && navs.length) {
    navs.forEach(function (nav) {
        var myMenu = new a11y_menu_1.Menu();
        myMenu.Create({
            nav: nav,
            config: {
                responsive: [{
                    minWidth: 0,
                    directions: [{
                        level: 0,
                        direction: 'y'
                    }]
                }, {
                    minWidth: 1280,
                    directions: [{
                        level: 0,
                        direction: 'x'
                    }]
                }]
            }
        });
    });
}
//# sourceMappingURL=index.js.map